type isSafariParams = {
    userAgent: string
}
const isSafari = ({userAgent}: isSafariParams) => {
    return userAgent.includes("Apple") && userAgent.includes("Safari") && !userAgent.includes("Chrome")
}

export default isSafari
